const Menu = [
    {
id: 1,
image:"images/E-Commerce.png",
name: "E-Commerce Development",
author: "Raj",
cotagary: "Software Development",
price: 2553,
discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
},
{
    id: 2,
    image:"images/Website Development.png",
    name: "Website Development",
    author: "Karan",
    cotagary: "Software Development",
    price: 2553,
    discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
    },
    {
        id: 3,
        image:"images/Mobile Application.png",
        name: "Mobile Application",
        author: "Kamal",
        cotagary: "Software Development",
        price: 2553,
        discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
        },
        {
            id: 4,
            image:"images/CMS Development.png",
            name: "CMS Development",
            author: "Rajesh",
            cotagary: "Software Development",
            price: 2553,
            discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
            },
            {
                id: 5,
                image:"images/WordPress Development-svg.png",
                name: "WordPress Development",
                author: "Rajat",
                cotagary: "CRM Development",
                price: 2553,
                discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                },
                {
                    id: 6,
                    image:"images/ERP Development.png",
                    name: "ERP Development",
                    author: "Ranjana",
                    cotagary: "CRM Development",
                    price: 2553,
                    discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                    },
                    {
                        id: 7,
                        image:"images/E Learning Development.png",
                        name: "E Learning Development",
                        author: "Rajkamal",
                        cotagary: "CRM Development",
                        price: 2553,
                        discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                        },
                        {
                            id: 8,
                            image:"images/Domain Hosting Services.png",
                            name: "Domain & Hosting Services",
                            author: "Rinki",
                            cotagary: "CRM Development",
                            price: 2553,
                            discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                            },
                            {
                                id: 9,
                                image:"images/ORM Service.png",
                                name: "ORM Service",
                                author: "Payal",
                                cotagary: "Digital Marketing",
                                price: 2553,
                                discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                },
                                {
                                    id: 10,
                                    image:"images/google-ads-verification-illustration.png",
                                    name: "Google Ads Service",
                                    author: "Rajkamal",
                                    cotagary: "Digital Marketing",
                                    price: 2553,
                                    discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                    },
                                    {
                                        id: 11,
                                        image:"images/search-engine-optimization-vector-21802541.png",
                                        name: "Search Engine Optimization",
                                        author: "Rinki",
                                        cotagary: "Digital Marketing",
                                        price: 2553,
                                        discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                        },
                                        {
                                            id: 12,
                                            image:"images/Social Media Optimization-svg.png",
                                            name: "Social Media Optimization",
                                            author: "Payal",
                                            cotagary: "Digital Marketing",
                                            price: 2553,
                                            discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                            },
                                            {
                                                id: 13,
                                                image:"images/SMO Packages.png",
                                                name: "SMO Packages",
                                                author: "Payal",
                                                cotagary: "Bulk SMS & Email",
                                                price: 2553,
                                                discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                                },
                                                {
                                                    id: 14,
                                                    image:"images/Virtual Number-svg.png",
                                                    name: "Virtual Number",
                                                    author: "Payal",
                                                    cotagary: "Bulk SMS & Email",
                                                    price: 2553,
                                                    discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                                    },
                                                    {
                                                        id: 15,
                                                        image:"images/Short Code Service.png",
                                                        name: "Short Code Service",
                                                        author: "Payal",
                                                        cotagary: "Bulk SMS & Email",
                                                        price: 2553,
                                                        discription:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Corporis, sunt reprehenderit eaque nobis magnam illo laboriosam ipsa natus, harum dolor omnis rerum, ipsam adipisci nesciunt perspiciatis tenetur ea culpa voluptate.",
                                                        },
];

export default Menu;